import { mapping } from '../emoji-unicode-mapping';
import { unknown } from './unknown';
export const emoji = node => {
  const value = mapping[node.attrs.id];
  if (value) {
    return value;
  }
  if (node.attrs.shortName) {
    return node.attrs.shortName;
  }
  return unknown(node);
};